export class BankCodeGroupConstant{
    public static readonly BANK_HSBC_BOC = ['4', '12', '19', '26', '30', '31', '33', '36', '64', '70'];
  	public static readonly BANK_PB_CBC = ['28', '39'];
  	public static readonly BANK_VIRTUAL = ['387', '388', '389', '390', '391', '392', '393', '395'];

	// PMS 30369
	public static readonly BANK_HSBC_BOC_DCI = ['4', '12', '14', '19', '26', '30', '31', '33', '36', '64', '70'];
	public static readonly BANK_VIRTUAL_DCI = ['387', '389', '390', '391', '392', '393', '395'];
}
